export default "__VITE_PUBLIC_ASSET__ce47d4ed__"